import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomIcon from '../../common/CustomIcon';
import * as bookApi from '../../../services/api/bookApi';
import LinkedActivityPopover from './LinkedActivityPopover';
import { ROLE } from '../../../const';

let hoverTimeout;

const parseLinkedClassrooms = response => {
  const data = response && response.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return [];
};

class LinkedContentTrigger extends Component {
  state = {
    isHovering: false,
    isLinked: false,
    linkedClassrooms: [],
    hasChecked: false
  };

  componentDidMount() {
    this.fetchLinkedClassrooms();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activityId !== this.props.activityId || prevProps.sectionId !== this.props.sectionId) {
      this.fetchLinkedClassrooms();
      return;
    }

    const { activityLinkChanged, activityId } = this.props;
    if (prevProps.activityLinkChanged !== activityLinkChanged && activityLinkChanged) {
      const changedActivityIds =
        activityLinkChanged.activityIds ||
        (activityLinkChanged.activityId ? [activityLinkChanged.activityId] : []);

      if (changedActivityIds.includes(activityId)) {
        this.fetchLinkedClassrooms();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(hoverTimeout);
  }

  fetchLinkedClassrooms = () => {
    const { activityId, sectionId, linked, role } = this.props;

    if (role === ROLE.STUDENT) {
      this.setState({ isLinked: false, hasChecked: true, linkedClassrooms: [] });
      return;
    }

    if (!activityId || !sectionId) {
      this.setState({ isLinked: !!linked, hasChecked: true, linkedClassrooms: [] });
      return;
    }

    bookApi
      .getLinkedClassroomsForActivity(activityId, sectionId)
      .then(res => {
        const linkedClassrooms = parseLinkedClassrooms(res);
        const isLinked = !!linked || linkedClassrooms.length > 1;
        this.setState({ linkedClassrooms, isLinked, hasChecked: true });
      })
      .catch(() => {
        this.setState({ isLinked: false, hasChecked: true, linkedClassrooms: [] });
      });
  };

  handleMouseEnter = () => {
    clearTimeout(hoverTimeout);
    this.setState({ isHovering: true });
  };

  handleMouseLeave = () => {
    hoverTimeout = setTimeout(() => this.setState({ isHovering: false }), 200);
  };

  stopPropagation = event => {
    event.stopPropagation();
  };

  render() {
    const { activityId } = this.props;
    const { isHovering, isLinked, linkedClassrooms, hasChecked } = this.state;

    if (!hasChecked || !isLinked) {
      return null;
    }

    return (
      <div
        className="linked-content-trigger"
        onClick={this.stopPropagation}
        onMouseDown={this.stopPropagation}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <span className="linked-content-trigger__icon">
          <CustomIcon name="share-content" size={16} color="#f8b02f" />
        </span>
        {isHovering && (
          <LinkedActivityPopover activityId={activityId} linkedClassrooms={linkedClassrooms} />
        )}
      </div>
    );
  }
}

LinkedContentTrigger.propTypes = {
  activityId: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
  linked: PropTypes.bool,
  activityLinkChanged: PropTypes.object,
  role: PropTypes.string
};

const mapStateToProps = state => ({
  activityLinkChanged: state.book.activityLinkChanged,
  role: state.classrooms.selectedClassroom.classroom.role
});

export default connect(mapStateToProps)(LinkedContentTrigger);
